"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Component = _interopRequireDefault(require("./Component.js"));
var _thumbnail = _interopRequireDefault(require("./thumbnail.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  handle: 'hhlBirds',
  label: 'Birds',
  component: _Component["default"],
  thumbnail: _thumbnail["default"],
  flowPlayerSettings: {
    background: 'solidColor',
    backgroundColor: '#fff'
  }
};
exports["default"] = _default;